import {
  FETCH_ALL_SPORTS,
  FETCH_SPORT_EVENTS,
  FETCH_SPORT_PARTICIPANTS,
  } from "../actions/types";

const sportsData = (state = "loading", action) => {
  switch (action.type) {
    case FETCH_ALL_SPORTS:
      return action.payload;
    default:
      return state;
  }
}

const sportEventsData = (state = "loading", action) => {
  switch (action.type) {
    case FETCH_SPORT_EVENTS:
      if(state !== "loading"){
        return {...state,...{[action.sportId]: {...action.payload}}}
      }
      return {[action.sportId]: action.payload}
    default:
      return state;
  }
}

const sportParticipantsData = (state = "loading", action) => {
  switch (action.type) {
    case FETCH_SPORT_PARTICIPANTS:
      if(state !== "loading"){
        return {...state,...{[action.sportId]: {...action.payload}}}
      }
      return {[action.sportId]: action.payload}
    default:
      return state;
  }
}


export default {
  sportsData,
  sportEventsData,
  sportParticipantsData,
}



// WEBPACK FOOTER //
// ./src/reducers/sportsReducer.js